import {showErrorNotification, showSuccessNotification} from "../../global/notifications";

let _id = null;

export default function (id) {
    _id = id;

    attachChangeEvent();
}

const attachChangeEvent = () => {
    const $baselineMeetingPercentInputs = $('[data-section="baseline-meeting-determinations"] input.js-percent[data-role="numerictextbox"]');
    $.each($baselineMeetingPercentInputs, function (index, ele) {
        const k_numericTextBox = $(ele).data('kendoNumericTextBox');
        if (k_numericTextBox) {
            //attach events
            k_numericTextBox.bind('change', function (e) {
                recalculateTotal();
            });
        }
    });
}

const recalculateTotal = () => {
    console.log("recalculating totals...")
    const $projectTeamGpPercent = $('[name="ProjectTeamGpPercent"]');
    const $gpStartPercent = $('[name="GpStartIncentivePercent"]');

    const k_projectTeamGpPercent = $projectTeamGpPercent.data('kendoNumericTextBox');
    const k_gpStartPercent = $gpStartPercent.data('kendoNumericTextBox');

    const contractAmount = Number($('[name="ContractValue"]').data('value'));
    console.log("Contract Amount => ", contractAmount)
    $('[name="ProjectTeamGp"]').text(kendo.toString((k_projectTeamGpPercent.value()/100) * contractAmount, 'c2'))
    $('[name="GpStartIncentive"]').text(kendo.toString((k_gpStartPercent.value()/100) * contractAmount, 'c2'))
}